const $inject = [];

const keyToLabelFilter = () => {
  return (s) => {
    return _.startCase(s);
  };
};

keyToLabelFilter.$inject = $inject;

export default keyToLabelFilter;



// WEBPACK FOOTER //
// ./src/filters/keyToLabelFilter.js